export const US_STATES = [
  'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia',
  'Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts',
  'Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey',
  'New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island',
  'South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia',
  'Wisconsin','Wyoming',
];

export const SPECIALTIES = [
  'Behavioral Health / Mental Health','Trauma','Anxiety','Depression','Grief & Loss','Life Transitions',
  'Addiction','Substance Abuse','Children & Adolescents','School Social Work','PTSD','Veterans',
  'Crisis Intervention','Couples & Family','Men\'s Issues','Medical / Health','Case Management',
  'Hospice / Palliative','Child Welfare','Foster Care & Adoption','Aging / Geriatrics','Disability / IDD',
  'LGBTQ+','Immigrants & Refugees','Domestic Violence','Homelessness / Housing','Corrections / Reentry',
  'Community Organizing','Clinical Supervision','Case / Care Coordination',
];

export const LICENSE_TYPES = ['LBSW','LMSW','LCSW','LCSW-S'];
export const SEMESTERS = ['Fall','Spring','Summer'];
export const DEGREE_LEVELS = ['BSW','MSW','Both'];
export const CONCENTRATIONS = ['Generalist','Clinical'];
export const FORMATS = [
  { value: 'in_person', label: 'In Person' },
  { value: 'remote', label: 'Remote' },
  { value: 'hybrid', label: 'Hybrid' },
];
